import script from "./not_found.vue?vue&type=script&setup=true&lang=js"
export * from "./not_found.vue?vue&type=script&setup=true&lang=js"

import "./not_found.vue?vue&type=style&index=0&id=75e74e12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75e74e12"]])

export default __exports__